var map = {
	"./audi_logo_de.svg": 8625,
	"./audi_logo_en.svg": 393,
	"./audi_logo_et.svg": 6051,
	"./audi_logo_sl.svg": 917,
	"./audi_logo_sv.svg": 639,
	"./audi_logo_white_de.svg": 251,
	"./audi_logo_white_en.svg": 9399,
	"./audi_logo_white_et.svg": 2461,
	"./audi_logo_white_sl.svg": 5483,
	"./audi_logo_white_sv.svg": 2401,
	"./audi_rings-black.svg": 8599,
	"./audi_rings-white.svg": 5485,
	"./audi_rings.png": 7822,
	"./cs_logo.png": 7917,
	"./flag_english.png": 2750,
	"./flag_estonia.png": 5695,
	"./flag_germany.png": 6133,
	"./flag_slovenia.png": 8289,
	"./flag_sweden.png": 8904,
	"./flag_unitedkingdom.png": 8618,
	"./germany.svg": 4821,
	"./login_background_fallback.png": 1574,
	"./logo.png": 4116,
	"./novomind.png": 5661,
	"./novomind_logo.png": 9083,
	"./novosales_logo.png": 9115,
	"./payment_logo_americanexpress.png": 9190,
	"./payment_logo_klarna.png": 469,
	"./payment_logo_maestro.png": 2323,
	"./payment_logo_mastercard.png": 4238,
	"./payment_logo_paypal.png": 67,
	"./payment_logo_sofort.png": 9531,
	"./payment_logo_visa.png": 7285,
	"./united-kingdom.svg": 1171
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8845;